
import Button from '@/ui-kit/components/button';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';

export default {
  name: 'ViewSwitcher',
  components: {
    Button,
  },
  props: {
    buttons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      StyleColorSchemeType,
      StyleSizeType,
    };
  },
};
